import { GET_LASTTOUCH_PATH_SERVICE } from 'api/services/content/paths';
import { apiCall } from '../../..';

export const getLastTouchService = async (params = {}) =>
    await apiCall.get(GET_LASTTOUCH_PATH_SERVICE, { params });
